<div class="main-navigation">
  <mat-nav-list
    class="portal"
    [ngClass]="(isHandset$ | async) ? 'mobile' : 'desktop'"
  >
    <a
      mat-list-item
      routerLink="./home"
      routerLinkActive="is-active"
      class="home"
    >
      <div class="nav-item-content">
        <mat-icon>dashboard</mat-icon>
        <div class="nav-label">
          {{ "mainNavigation.dashboard" | translate }}
        </div>
      </div>
    </a>
    <a
      mat-list-item
      routerLink="./users"
      routerLinkActive="is-active"
      class="users"
    >
      <div class="nav-item-content">
        <!-- <mat-icon>supervised_user_circle</mat-icon> -->
        <mat-icon>bar_chart</mat-icon>
        <div class="nav-label">{{ "mainNavigation.activity" | translate }}</div>
      </div>
    </a>
    <a
      mat-list-item
      routerLink="./projects"
      routerLinkActive="is-active"
      class="projects"
    >
      <div class="nav-item-content">
        <mat-icon>apartment</mat-icon>
        <div class="nav-label">{{ "mainNavigation.projects" | translate }}</div>
      </div>
    </a>
    <a
      mat-list-item
      routerLink="./health"
      routerLinkActive="is-active"
      class="health"
    >
      <div class="nav-item-content">
        <!-- <mat-icon>heart_broken</mat-icon>  -->
        <mat-icon>health_and_safety</mat-icon>
        <div class="nav-label">{{ "mainNavigation.health" | translate }}</div>
      </div>
    </a>
    <a
      mat-list-item
      routerLink="./dgnb"
      routerLinkActive="is-active"
      class="dgnb-systems"
    >
      <div class="nav-item-content">
        <mat-icon>store</mat-icon>
        <div class="nav-label">{{ "mainNavigation.dgnb" | translate }}</div>
        <div class="nav-label second-row">
          {{ "mainNavigation.dgnb2" | translate }}
        </div>
      </div>
    </a>
    <a mat-list-item routerLink="./appConfig" routerLinkActive="is-active">
      <div class="nav-item-content">
        <mat-icon>settings</mat-icon>
        <div class="nav-label">
          {{ "mainNavigation.appConfig1" | translate }}
        </div>
        <div class="nav-label second-row">
          {{ "mainNavigation.appConfig2" | translate }}
        </div>
      </div>
    </a>
    <a mat-list-item routerLink="./rights-management" routerLinkActive="is-active">
      <div class="nav-item-content">
        <mat-icon>admin_panel_settings</mat-icon>
        <div class="nav-label">
          {{ "mainNavigation.rightsManagement1" | translate }}
        </div>
        <div class="nav-label second-row">
          {{ "mainNavigation.rightsManagement2" | translate }}
        </div>
      </div>
    </a>
  </mat-nav-list>
  <mat-nav-list
    class="misc"
    [ngClass]="(isHandset$ | async) ? 'mobile' : 'desktop'"
    (click)="_authService.logout()"
  >
    <a mat-list-item class="logout">
      <div class="nav-item-content">
        <mat-icon>logout</mat-icon>
        <div class="nav-label">Ausloggen</div>
      </div>
    </a>
  </mat-nav-list>
</div>
